import script from "./storageContractReview.vue?vue&type=script&setup=true&lang=js"
export * from "./storageContractReview.vue?vue&type=script&setup=true&lang=js"

import "./storageContractReview.vue?vue&type=style&index=0&id=83662ad6&lang=less"

const __exports__ = script;

export default __exports__